import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { FilterSortDirection, getValues } from '@gov-nx/core/types';
import { toStringDate, today, useDateShape } from '@gov-nx/utils/common';
import type { PageCode } from '../../definitions/codes';
import type {
	DataRequest,
	MySubmissionListFilterForm,
	MySubmissionsListFilter,
} from './context.types';
import { MySubmissionListOrder } from './context.types';

export interface FormInstanceProps {
	code: PageCode;
	defaultValues: MySubmissionListFilterForm;
}

export function FormInstance({
	code,
	defaultValues,
}: FormInstanceProps): FormDefinition<MySubmissionListFilterForm> {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);
	const { getDatePickerShape } = useDateShape();

	const formSchema = yup
		.object({
			razeni: yup.string().oneOf(getValues(MySubmissionListOrder)).optional(),
			lhutaVyrizeni: getDatePickerShape().nullable(),
			vyrizeno: getDatePickerShape()
				.max(today(), tsn('form.validations.datum-ukonu-maximum'))
				.nullable(),
			razeniSmer: yup.string().oneOf(getValues(FilterSortDirection)).optional(),
			hledat: yup.string().optional(),
		})
		.required();

	const formMethods = useGovForm<MySubmissionListFilterForm>({
		formSchema,
		defaultValues,
	});
	return getFormDefinition({ formMethods, formSchema });
}

export const prepareSubmitData = (
	formData: MySubmissionsListFilter
): DataRequest => {
	const order = (
		formData.razeniSmer === FilterSortDirection.DESC
			? '-' + formData.razeni
			: formData.razeni
	) as MySubmissionListOrder;

	return {
		params: {
			razeni: order,
			lhutaVyrizeni: formData.lhutaVyrizeni
				? toStringDate(formData.lhutaVyrizeni)
				: undefined,
			vyrizeno: formData.vyrizeno ? toStringDate(formData.vyrizeno) : undefined,
			start: formData.start,
			pocet: formData.pocet,
		},
	};
};
